/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Вид попапа подтверждения оплаты для услуг
   */
  app.PaymentConfirmationPopupView = app.View.extend({
    el: '.b-popup-payment-confirmation',

    /**
     * Опции идентификаторов оплаты и заказа.
     */
    additionalOptions: ['paymentId', 'orderId'],

    /** @inheritDoc **/
    run: function () {
      this._initPopup();
      this.render();
    },

    /**
     * Инициализация попапа
     * @private
     */
    _initPopup: function () {
      var that = this;
      this.popup = new als.Popup($(this.el));
      this.popup.addEventListener(
        als.Popup.EventType.BEFORE_CLOSE,
        function () {
          that.childViews.confirmationBody.clearTimer();
        }
      );
    },

    /**
     * Очистка URL от GET параметров order и payment
     * @private
     */
    _clearUrl: function () {
      var params = _.omit(app.helpers.UrlHelper.getUrlParameters(), ['order', 'payment']);
      window.history.pushState('Remove GET param', window.location.pathname, window.location.pathname + '?' + $.param(params));
    },

    /** @inheritDoc */
    render: function () {
      this._clearUrl();
      this.childViews.confirmationBody = new app.ServiceOrderStatusView({
        el: '.js-popup-body',
        orderId: this.orderId,
        paymentId: this.paymentId,
      });
      this.popup.open();
    }

  });

})(jQuery);

}.call(window));